import axios from 'axios';
import config from '../config';

export function getSeoConfig() {
  // pageNum=1&pageSize=1 per requirements, take first row if exists
  return axios.get(`${config.API_BASE_URL}/system/seoConfig/list`, {
    params: { pageNum: 1, pageSize: 1 }
  });
}


